import { render } from "./JobDispatcherMappingModal.vue?vue&type=template&id=0d60625c&scoped=true"
import script from "./JobDispatcherMappingModal.vue?vue&type=script&lang=js"
export * from "./JobDispatcherMappingModal.vue?vue&type=script&lang=js"

import "./JobDispatcherMappingModal.vue?vue&type=style&index=0&id=0d60625c&scoped=true&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d60625c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCardSection,QTabs,QTab,QTabPanels,QTabPanel,QBtn});qInstall(script, 'directives', {ClosePopup});
